<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="confirmarAprovacao()">
            <span> <i class="fa fa-check-circle-o mr-2"></i> Aprovar </span>
        </b-button>
    </div>
</template>

<script>
import SolicitacoesAcessoServicos from './SolicitacoesAcessoServicos'

export default {
    props: {
        solicitacaoAcessoId: {
            type: String,
            default: ''
        },

        cpfCnpjFornecedor: {
            type: String,
            default: ''
        },

        razaoSocialFornecedor: {
            type: String,
            default: ''
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarAprovacao() {
            this.$swal({
                title: 'Solicitação de Acesso',
                html: `Confirma a APROVAÇÃO da solicitação de acesso do fornecedor
                    ${this.cpfCnpjFornecedor} - ${this.razaoSocialFornecedor}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aprovarSolicitacaoAcesso()
                }
            })
        },

        aprovarSolicitacaoAcesso() {
            this.$store.dispatch('addRequest')
            SolicitacoesAcessoServicos.aprovar(this.solicitacaoAcessoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.$emit('atualizarErro', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Solicitação de acesso aprovada com sucesso',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterSolicitacaoAtualizada')
        }
    }
}
</script>
